import React, { useState, useEffect } from "react";
import { useTable, useFilters, useSortBy, usePagination } from "react-table";
import "../../containers/Accounting/Accounting.scss";

export default function AccountingTable({
  columns,
  data,
  defaultColumn,
  endRow,
  filterTypes,
  getLedger,
  lastPage,
  loading,
  offset,
  onOffset,
  pageCount: controlledPageCount,
  sortDesc,
  sortId,
  totalItems,
  update,
}) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state: { pageIndex },
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
  } = useTable(
    {
      autoResetPage: false,
      columns,
      filterTypes,
      data,
      defaultColumn,
      initialState: {
        pageSize: 30,
        sortBy: [
          {
            id: sortId,
            desc: sortDesc,
          },
        ],
      },
      pageCount: controlledPageCount,
    },
    useFilters,
    useSortBy,
    usePagination
  );

  const handleGoToPreviousPage = () => {
    onOffset(offset - 30);
    setTimeout(() => {
      getLedger();
    },100)
  };

  const handleGoToNextPage = () => {
    onOffset(offset + 30);
    setTimeout(() => {
      getLedger();
    },100)
  };

  // Render the UI for your table\
  return (
    <>
      <table
        className=""
        style={{
          width: "100%",
          flex: "0 0 100%",
          position: "relative",
        }}
        {...getTableProps()}
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className={
                    column.isSorted
                      ? column.isSortedDesc
                        ? "sort-desc"
                        : "sort-asc"
                      : ""
                  }
                >
                  {column.render("Header")}
                  <br />
                  {column.canFilter ? column.render("Filter") : null}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.length === 0 ? (
            <td colSpan={columns.length} style={{ textAlign: "center" }}>
              No Results Found
            </td>
          ) : (
            page.map((row, i) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>
                      {cell && cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })
          )}
        </tbody>
      </table>
      {totalItems > 30 && (
        <div className="pagination">
          <span className="pagination-index">
            Page{" "}
            <strong>
              {(30 + offset) / 30} of {lastPage}
            </strong>{" "}
          </span> 
          {((30 + offset) / 30) > 1 && (
            <button
              className="pagination-nav arrow-left"
              onClick={() => handleGoToPreviousPage()}
              disabled={((30 + offset) / 30) === 1}
            >
              {"<"}
            </button>
          )}
          {((30 + offset) / 30) < lastPage && (
            <button
              className="pagination-nav arrow-right"
              onClick={() => handleGoToNextPage()}
              disabled={((30 + offset) / 30) === lastPage}
            >
              {">"}
            </button>
          )}
        </div>
      )}
    </>
  );
}